<template>
  <div class="top-breweries">
    <v-data-table
      caption="Öl per bryggeri"
      disable-filtering
      :headers="headers"
      :items="breweries"
      :items-per-page="7"
      :mobile-breakpoint="350"
      class="py-6 mx-n2 mb-6"
      locale="sv-SE"
      :footer-props="{
        itemsPerPageOptions: [7, 20, 60, -1],
        itemsPerPageAllText: 'Alla',
        itemsPerPageText: 'Per sida:',
      }"
    >
      <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
        {{ pageStart }} - {{ pageStop }} av {{ itemsLength }}
      </template>
    </v-data-table>
  </div>
</template>
<script>
import _ from 'lodash'

export default {
  name: 'TopListBreweries',
  data () {
    return {
      headers: [
        {text: 'Namn', value: 'brewery'},
        {text: '∑', value: 'count'},
      ]
    }
  },
  computed: {
    breweries () {
      const breweriesData = this.$store.getters.breweriesData
      let breweries = []
      breweriesData.forEach(brewery => {
        breweries.push({
          brewery: brewery.brewery,
          count: brewery.count
        })
      })
      return _.orderBy(breweries, 'count', 'desc')
    }
  }
}
</script>
<style lang="scss">
  .v-data-table {
    .text-start:last-child {
      margin-left: 0;
      margin-right: 0;
      padding-left: 0;
      padding-right: 0;
    }
    .v-data-footer {
     justify-content: space-around;
    }
    .v-data-footer__select,
    .v-data-footer__pagination,
    .v-data-footer__select .v-select {
      margin: 8px;
    }
  }
</style>
